module.exports = __webpack_public_path__ + "static/3-59474e9c2200423ad9432e7dc288ba09.jpg";